import PageBanner from '../components/PageBanner';
import { BANNER_IMAGES, SERVICE_IMAGES } from '../components/Images';
import { motion } from 'framer-motion';

const services = [
  {
    title: 'Industrial Control Panels',
    description: 'Precision-engineered for seamless industrial process control.',
    image: SERVICE_IMAGES.INDUSTRIAL_CONTROL_PANELS,
  },
  {
    title: 'Panel Boxes',
    description: 'Sturdy enclosures for electrical component protection and organization.',
    image: SERVICE_IMAGES.PANEL_BOXES,
  },
  {
    title: 'Electric Breakers',
    description: 'Safeguarding circuits from overloads and short circuits.',
    image: SERVICE_IMAGES.ELECTRIC_BREAKERS,
  },
  {
    title: 'Earthing Electrodes',
    description: 'Safely dissipating electrical energy into the ground.',
    image: SERVICE_IMAGES.EARTHING_ELECTRODES,
  },
  {
    title: 'Outdoor Panels',
    description: 'Robust enclosures for outdoor electrical installations.',
    image: SERVICE_IMAGES.OUTDOOR_PANELS,
  },
  {
    title: 'Distribution Box',
    description: 'Efficient power distribution within buildings and facilities.',
    image: SERVICE_IMAGES.DISTRIBUTION_BOX,
  },
  {
    title: 'Copper Rods',
    description: 'High-conductivity grounding solutions for safety.',
    image: SERVICE_IMAGES.COPPER_RODS,
  },
  {
    title: 'PLC Panels',
    description: 'Advanced control for industrial automation and optimization.',
    image: SERVICE_IMAGES.PLC_PANELS,
  },
  {
    title: 'Earthing Powder and Compound',
    description: 'Enhancing grounding system conductivity.',
    image: SERVICE_IMAGES.EARTHING_POWDER,
  },
  {
    title: 'DG Synchronizing Panels',
    description: 'Seamless integration for backup power systems.',
    image: SERVICE_IMAGES.DG_SYNCHRONIZING,
  },
  {
    title: 'Drive Panels',
    description: 'Control solutions for variable speed drives in industries.',
    image: SERVICE_IMAGES.DRIVE_PANELS,
  },
  {
    title: 'Control Desk',
    description: 'Centralized monitoring and control for complex systems.',
    image: SERVICE_IMAGES.CONTROL_DESK,
  },
  {
    title: 'Terminal Junction Box',
    description: 'Versatile enclosures for electrical connections.',
    image: SERVICE_IMAGES.TERMINAL_JUNCTION,
  },
  {
    title: 'Feeder Pillar',
    description: 'Integrated outdoor power distribution pillars.',
    image: SERVICE_IMAGES.FEEDER_PILLAR,
  },
  {
    title: 'Unitized Substation',
    description: 'Compact and efficient power distribution solutions.',
    image: SERVICE_IMAGES.UNITIZED_SUBSTATION,
  },
  {
    title: 'Electrical Projects',
    description: 'Comprehensive electrical system design and installation.',
    image: SERVICE_IMAGES.ELECTRICAL_PROJECTS,
  },
  {
    title: 'Electrical Raceway',
    description: 'Durable wiring routing and protection systems.',
    image: SERVICE_IMAGES.ELECTRICAL_RACEWAY,
  },
  {
    title: 'Digital Control Desk System',
    description: 'Advanced monitoring and optimization capabilities.',
    image: SERVICE_IMAGES.DIGITAL_CONTROL,
  },
  {
    title: 'Repairing and Maintenance Services',
    description: 'Reliable electrical equipment upkeep.',
    image: SERVICE_IMAGES.REPAIR_MAINTENANCE,
  },
  {
    title: 'Panel Installation Services',
    description: 'Expert panel installation tailored to needs.',
    image: SERVICE_IMAGES.PANEL_INSTALLATION,
  },
  {
    title: 'Electrical Relay',
    description: 'Fast and reliable electrical circuit control.',
    image: SERVICE_IMAGES.ELECTRICAL_RELAY,
  },
  {
    title: 'Power Distribution Equipment',
    description: 'Complete range for efficient energy management.',
    image: SERVICE_IMAGES.POWER_DISTRIBUTION,
  },
  {
    title: 'Commercial Services',
    description: 'Customized electrical solutions for businesses.',
    image: SERVICE_IMAGES.COMMERCIAL_SERVICES,
  },
  {
    title: 'Control Panels',
    description: 'Custom-designed panels for industrial applications.',
    image: SERVICE_IMAGES.CONTROL_PANELS,
  },
  {
    title: 'Earthing Strip',
    description: 'Low impedance grounding conductor strips.',
    image: SERVICE_IMAGES.EARTHING_STRIP,
  },
  {
    title: 'APFC Relays',
    description: 'Automatic power factor correction for energy efficiency.',
    image: SERVICE_IMAGES.APFC_RELAYS,
  },
  {
    title: 'Industrial Stabilizer',
    description: 'Voltage stabilization for consistent performance.',
    image: SERVICE_IMAGES.INDUSTRIAL_STABILIZER,
  },
  {
    title: 'Electrical Rising Mains',
    description: 'Reliable power distribution in multi-story buildings.',
    image: SERVICE_IMAGES.ELECTRICAL_RISING,
  },
  {
    title: 'Electrical Cable and Wire',
    description: 'High-quality cables for various applications.',
    image: SERVICE_IMAGES.ELECTRICAL_CABLE,
  },
  {
    title: 'Lightning Arrester',
    description: 'Protection against lightning strikes.',
    image: SERVICE_IMAGES.LIGHTNING_ARRESTER,
  },
  {
    title: 'ACB Panels',
    description: 'Air circuit breaker panels for electrical circuits.',
    image: SERVICE_IMAGES.ACB_PANELS,
  },
  {
    title: 'Electrical Turnkey Project',
    description: 'End-to-end electrical solutions.',
    image: SERVICE_IMAGES.ELECTRICAL_TURNKEY,
  },
  {
    title: 'Bus Ducts',
    description: 'Efficient power distribution in industrial settings.',
    image: SERVICE_IMAGES.BUS_DUCTS,
  },
  {
    title: 'Capacitors and Insulators',
    description: 'Energy storage and electrical insulation materials.',
    image: SERVICE_IMAGES.CAPACITORS_INSULATORS,
  },
];

const ServicesPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="relative pt-32 pb-24 bg-white">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-gray-50" />
        <div className="relative container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-block mb-6">
              <span className="text-blue-600 text-sm font-semibold tracking-wider uppercase">Services</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Our <span className="text-blue-600">Services</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Discover our comprehensive range of electrical services designed to meet your specific needs and requirements.
            </p>
            <div className="h-1 w-24 bg-blue-600 mx-auto rounded-full"></div>
          </div>
        </div>
      </section>
      
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <ServiceCard
                title={service.title}
                description={service.description}
                image={service.image}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

const ServiceCard = ({ title, description, image }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
      <div className="relative h-48 overflow-hidden">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-bold mb-2 text-gray-800 group-hover:text-[#1a237e] transition-colors duration-300">
          {title}
        </h3>
        <p className="text-gray-600 mb-4">{description}</p>
        <button className="text-[#1a237e] font-medium hover:text-[#283593] transition-colors duration-300">
          Read More →
        </button>
      </div>
    </div>
  );
};

export default ServicesPage; 